import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'options.tracker.email.verify@gmail.com';
  const [showCopied, setShowCopied] = useState(false);

  const handleSupportClick = async (e) => {
    // Try to open mailto: link
    const mailtoUrl = `mailto:${supportEmail}?subject=Options%20Tracker%20Support`;

    // Create a hidden iframe to test if mailto: works
    // If it doesn't open anything within a short time, copy to clipboard
    const start = Date.now();
    window.location.href = mailtoUrl;

    // Check if we're still on the same page after a delay
    // If so, the mailto: likely didn't work - copy to clipboard as fallback
    setTimeout(async () => {
      // If more than 500ms passed and we're still here, mailto probably failed
      if (Date.now() - start >= 400) {
        try {
          await navigator.clipboard.writeText(supportEmail);
          setShowCopied(true);
          setTimeout(() => setShowCopied(false), 3000);
        } catch (err) {
          // Clipboard API failed, show alert as last resort
          alert(`Email: ${supportEmail}`);
        }
      }
    }, 500);
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/about">About</Link>
          <Link to="/how-to-use">How to Use</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/calculators">Calculators</Link>
          <button
            type="button"
            className="footer-link-button"
            onClick={handleSupportClick}
          >
            Support
            {showCopied && <span className="copied-tooltip">Email copied!</span>}
          </button>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
          <Link to="/refund-policy">Refund Policy</Link>
          {/* Future links can be added here:
          <Link to="/contact">Contact</Link>
          <Link to="/feedback">Feedback</Link>
          */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;


